import React, { FC } from 'react'
import { Tabs as TabsAntd, TabsProps } from 'antd'
import './tabs.scss'

const Tabs: FC<TabsProps> = (props) => (
	<TabsAntd className="ui-tabs" {...props} />
)

export default Tabs
